<div class="flex flex-col items-center justify-center p-8 text-center">
  <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
    <doka-icon [name]="icon()" class="text-gray-400 text-5xl" />
  </div>
  <p class="text-lg font-medium text-gray-700 mb-2">
    {{ message() | i18nextEager }}
  </p>
  @if (description()) {
    <p class="text-sm text-gray-500 max-w-md">
      {{ description()! | i18nextEager }}
    </p>
  }
</div>
